import { useState } from "react";

import { TextArea } from "@king-ict/eupisi-ui/components";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface IProps {
  show: boolean;
  onHide: () => void;
  onConfirm: (note: string) => void;
}

const MAX_LENGTH = 1000;

export const ConfirmationModal = ({ show, onHide, onConfirm }: IProps) => {
  const [note, setNote] = useState("");
  const { t } = useTranslation();

  const handleConfirm = () => {
    onConfirm(note.trim());
    setNote("");
    onHide();
  };

  const exceededMaxLength = note.length > MAX_LENGTH;
  // The user can leave it empty but is not allowed to just send whitespaces
  const isOnlyWhitespace = note.length > 0 && note.trim().length === 0;
  const rowAmount = Math.ceil(note.length / 100) + 1;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {t("common.schoolCandidateModel.confirmationModalTitle")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TextArea
          ariaLabel={t("common.schoolCandidateModel.confirmationModalNote")}
          label={t("common.schoolCandidateModel.confirmationModalNote")}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          rows={rowAmount}
          errorText={exceededMaxLength ? t("validations.maxLengthError") : ""}
          helperText={`${note.length} / ${MAX_LENGTH}`}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button color="warning" onClick={onHide}>
          {t("common.cancel")}
        </Button>
        <Button
          color="primary"
          onClick={handleConfirm}
          disabled={exceededMaxLength || isOnlyWhitespace}
        >
          {t("common.confirm")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
